export const Similarity = [
  {
    title: "اقل دقه",
    value: "0.85",
  },
  {
    title: "دقيق",
    value: "0.90",
  },
  {
    title: "دقيق جدا",
    value: "0.95",
  },
  {
    title: "تطابق تام",
    value: "0.99",
  },
];
